import { render, staticRenderFns } from "./productFee.vue?vue&type=template&id=29fdd53f&scoped=true&"
import script from "./productFee.vue?vue&type=script&lang=js&"
export * from "./productFee.vue?vue&type=script&lang=js&"
import style0 from "./productFee.vue?vue&type=style&index=0&id=29fdd53f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fdd53f",
  null
  
)

export default component.exports